type ApiFilterConfig = {
    fieldName: string;
    apiParamName?: string;
    apiValueConverter?: (value: any) => any;
};

type DataTableCriteria = {
    first?: number;
    rows?: number;
    sortField?: string | null;
    sortOrder?: 1 | -1 | null;
    baseQuery?: string;
    filters?: Record<string, any>;
};

export class DataTableCriteriaQueryMapper {
    constructor(private readonly filterConfig: ApiFilterConfig[]) {}

    toProductInventoryParams(
        criteria: DataTableCriteria,
        showOnlyActive: boolean,
    ): Record<string, unknown> {
        return {
            first: criteria.first ?? 0,
            max: criteria.rows ?? 10,
            sort_field: criteria.sortField ?? undefined,
            sort_asc:
                criteria.sortOrder == null
                    ? undefined
                    : criteria.sortOrder === 1,
            only_active: showOnlyActive,
            base_query: criteria.baseQuery || undefined,
            ...this.mapFilters(criteria.filters),
        };
    }

    private mapFilters(filters: Record<string, any> = {}): Record<string, unknown> {
        return Object.entries(filters).reduce<Record<string, unknown>>(
            (params, [fieldName, filter]) => {
                const config = this.findConfig(fieldName);
                const value = this.resolveFilterValue(filter);

                if (this.isEmpty(value)) return params;

                const apiParamName = config?.apiParamName ?? fieldName;

                params[apiParamName] = config?.apiValueConverter
                    ? config.apiValueConverter(value)
                    : this.normalizeValue(value);

                return params;
            },
            {},
        );
    }

    private findConfig(fieldName: string): ApiFilterConfig | undefined {
        return this.filterConfig.find(config => config.fieldName === fieldName);
    }

    private resolveFilterValue(filter: any): any {
        if (filter == null) return undefined;
        if (typeof filter !== 'object') return filter;
        return filter.value;
    }

    private normalizeValue(value: any): any {
        if (Array.isArray(value)) {
            return value
                .map(item => item?.id ?? item?.value ?? item)
                .join(',');
        }

        if (typeof value === 'object') {
            if ('from' in value || 'to' in value) {
                return undefined;
            }

            return value?.id ?? value?.value ?? value;
        }

        return value;
    }

    private isEmpty(value: unknown): boolean {
        return (
            value == null ||
            value === '' ||
            (Array.isArray(value) && value.length === 0)
        );
    }
}